module.exports = __webpack_public_path__ + "img/data_other.c9592fd9.png";